import { useEffect } from 'react';
import Prism from 'prismjs';

import './PrismLoader.css';

function PrismLoader() {
  useEffect(() => {
    // Call the highlightAll() function to style our code blocks.
    Prism.highlightAll();
  });

  return null;
}

export default PrismLoader;
